import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import smartSchedule1 from '../../assets/images/smart-schedule-1.png';
import smartSchedule2 from '../../assets/images/smart-schedule-2.png';
import smartSchedule3 from '../../assets/images/smart-schedule-3.png';
import { border1 } from 'utils/style/colors';

const Container = styled.div`
  max-height: 70vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Picture = styled.img`
  max-width: 80%;
  border-radius: 1rem;
  object-fit: contain;
  border: ${border1};
  margin: 0.5rem auto;
`;

const Text = styled.div``;

interface IProps {}

const MoreInfoModalContent: FC<IProps> = () => {
  const { t } = useTranslation('taskManager');

  return (
    <Container>
      <Content>
        <Text>{t('smartScheduleBtn')}</Text>
        <Picture src={smartSchedule1} />
      </Content>
      <Content>
        <Text>{t('defineTasksRange')}</Text>
        <Picture src={smartSchedule2} />
      </Content>
      <Content>
        <Text>{t('calcAndPreviewSmartScheduleInformation')}</Text>
        <Picture src={smartSchedule3} />
      </Content>
      <Content>
        <Text>{t('finalContent')}</Text>
      </Content>
      <Content>
        <Text>{t('noteToSmartSchedule')}</Text>
      </Content>
    </Container>
  );
};

export default MoreInfoModalContent;
